export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/david-marcu-8f9581dbf863fcb3494a8bbe0f89d6eb.jpg";